<template>
	<div class="bannerinner">
		<div class="banner">
		    <div class="swiper banbox">
		        <div class="swiper-wrapper">
		          <div class="swiper-slide" v-for="item in bannDatas" :key="item.id"><router-link :to="{path:item.url}"><img :src="item.thumb" :alt="item.name"></router-link></div>

		          <!-- <div class="swiper-slide"><a href=""><img src="@/assets/images/comban8.jpg" alt=""></a></div>
		          <div class="swiper-slide"><a href=""><img src="@/assets/images/comban9.jpg" alt=""></a></div> -->
		        </div>
		        <div class="swiper-pagination"></div>
		    </div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import "swiper/css/swiper.min.css"
	import $ from 'jquery'
	import {request} from '../network/request.js'
	import GLOBAL from '../global/global.js'
	export default{
		name:"Bannerinner",
		data(){
			return{
				bannData:[]
			}
		},
		methods:{
			getban(){
				let that = this
				request({
					url: '/index/banner?id=4',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							let beforeData = jsondata['data']
							jsondata['data'].forEach(function(value,index,arr){
		
								
								if(value['thumb'].length > 100){
									let beforeimg = value['thumb'].split(':')[21];
									value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
									
								}
					
								
							})
							that.bannData = jsondata['data']
							// console.log(that.bannData)
							
							// console.log(that.bannData)
				
						}
					}]
				})
			}
		},
		computed:{
			bannDatas(){
				let listData = this.bannData
				listData.forEach(item => {
					item['url'] = item['url'].replace('https://m.guanlingls.com/','/')
				})
				return listData
			}
		},
		mounted() {
			this.getban()
			setTimeout(function(){
				new Swiper(".banbox", {
					slidesPerView: 1,
					spaceBetween: 30,
					loop: true,
					pagination: {
					  el: ".swiper-pagination",
					  clickable: true,
					},
					autoplay:{
						delay:5000,
						disableOnInteraction: false
					}
				  });
			},300)
		}
	}
</script>

<style scoped>
	.banner{
	        overflow: hidden;
	        position: relative;
	    }
	    .swiper-pagination-bullets{
	        bottom: 0rem !important;
	    }
	    .swiper-pagination-clickable .swiper-pagination-bullet{
	        opacity: 1;
	        background-color: #979191;
	        box-shadow: 0 0 1px 1px #fff;
	        margin: 0 5px;
	    }
	    .swiper-pagination-bullet-active{
	        background: #cc131d !important;
	    }
</style>